/* RESPONSIBLE TEAM: team-fin-voice */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';
import type FinVoiceConfigService from 'embercom/services/fin-voice-config-service';

export default class SettingsPronunciationsRoute extends Route {
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @service declare appService: AppService;
  @service declare finVoiceConfigService: FinVoiceConfigService;

  get analytics() {
    if (this.appService.app.canUseStandalone) {
      return { section: 'settings', place: 'pronunciations' };
    }
    return { section: 'ai-chatbot', place: 'settings.pronunciations' };
  }

  get titleToken(): string {
    return this.intl.t('ai-agent.voice-playground.pronunciations-title');
  }

  async beforeModel() {
    if (this.appService.app.canUseStandalone) {
      if (!this.appService.app.canUseStandaloneDeployPhone) {
        this.router.replaceWith('apps.app.settings.index');
      }
    } else {
      let canAccess = await this.finVoiceConfigService.canAccessFinVoice();
      if (!canAccess) {
        this.router.replaceWith('apps.app.settings.ai-automation.fin-ai-agent');
      }
    }
  }
}
